import OrderHelperObject from "../../../../domains2/orders/OrderHelperObject";
import { generateOrderLines, getGTMFlattenSingleProductSelection, getGTMTotalPrice } from "../gtmHelper";
import { pushGTMInternal } from "../pushGtmEvents";
import { pushGTMeCommerceData } from "../pushGTMeCommerceData";
import { UPSELL_FLOWS } from "../../../../libraries/globalTemplateSpecific/bm100/utils";

export const gtmTrackAddToBasketFromUpsellRules = (self, {productSelections, item, upsellFlow}) => {
	try {
		const productCatalog = self.$store.getters.productCatalog;
		const ol = generateOrderLines(self, {productCatalog, productSelections});
		const mainProduct = OrderHelperObject.mapToReceiptLines(ol, self.$i18n)[0];
		const productWithSubProducts = getGTMFlattenSingleProductSelection(mainProduct);
		const products = productWithSubProducts.length ? productWithSubProducts : productSelections;
		pushGTMeCommerceData({
			eventName: "add_to_cart",
			products: products,
			value: getGTMTotalPrice(products),
			category: productCatalog.getDepartment(item.departmentId)
		});
		if(upsellFlow === UPSELL_FLOWS.RCM_MARKETING_CARD) {
			pushGTMInternal(
				"RCMCrossSell",
				item.name,
				self.$route.path,
				"",
				{
					email: (self.$store.getters.getUserData || {}).email,
					selectedRestaurant: (self.globalSelectedShop || {}).shopName,
					upsellValue: productSelections[0].price
				}
			);
		}
	} catch (e) {
		// even if something here fails, we should proceed
	}
};